'use client'

import { useEffect } from 'react'

import { Router } from 'next/router'
import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { Environment } from 'utils/env'
import { getEnvironmentByDomain } from 'utils/env'

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const env = getEnvironmentByDomain(window.location.hostname)
    if (env === Environment.Local) {
      return
    }

    if (env === Environment.Demo) {
      // eslint-disable-next-line alternative/no-invalid-env-usage
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
        api_host:
          // eslint-disable-next-line alternative/no-invalid-env-usage
          process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
        person_profiles: 'never'
      })

      return
    }

    // eslint-disable-next-line alternative/no-invalid-env-usage
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
      api_host:
        // eslint-disable-next-line alternative/no-invalid-env-usage
        process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
      person_profiles: 'identified_only',
      capture_exceptions: {
        capture_console_errors: false,
        capture_unhandled_errors: true,
        capture_unhandled_rejections: true
      }
    })

    const handleRouteChange = () => posthog?.capture('$pageview')

    Router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      Router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [])

  return <PHProvider client={posthog}>{children}</PHProvider>
}
